import React from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { ArrowLeft, Check } from 'lucide-react';
import { usePlanSelection } from '../hooks/subscriptions/usePlanSelection';
import { useSubscription } from '../hooks/subscriptions/useSubscription';
import { useAuth } from '../context/AuthContext';
import { LoadingSpinner } from '../components/common/LoadingSpinner';
import { SUBSCRIPTION_PLANS } from '../constants/subscriptionPlans';

export function SubscriptionPage() {
  const { subscription, isLoading: isLoadingSubscription } = useSubscription();
  const { isProcessing, handlePlanSelection } = usePlanSelection();
  const { isAdmin } = useAuth();
  const isLoading = isLoadingSubscription || isProcessing;

  return (
    <div className="min-h-screen bg-background-dark py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="mb-8">
          <Link
            to="/dashboard"
            className="inline-flex items-center text-accent-green hover:opacity-80"
          >
            <ArrowLeft className="h-5 w-5 mr-2" />
            Back to Dashboard
          </Link>
        </div>

        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-black">Choose Your Plan</h1>
          <p className="mt-4 text-lg text-black">
            Select the plan that best fits your needs
          </p>
        </div>

        <div className="flex justify-center">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl w-full">
            {SUBSCRIPTION_PLANS.map((plan) => (
                <div
                  key={plan.id}
                  className={`
                    bg-background-card rounded-2xl p-6 border-2 transition-all
                    ${subscription?.plan?.id === plan.id 
                      ? 'border-accent-green' 
                      : 'border-gray-800 hover:border-accent-green'
                    }
                  `}
                >
                  <div className="text-center mb-6">
                    <h3 className="text-xl font-bold text-black">{plan.name}</h3>
                    <p className="text-black text-sm">{plan.description}</p>
                    <div className="mt-4">
                      <span className="text-3xl font-bold text-black">
                        {plan.price === 0 ? 'Free' : `$${(plan.price / 100).toFixed(2)}`}
                      </span>
                      {plan.price > 0 && (
                        <span className="text-black text-sm">/{plan.interval}</span>
                      )}
                    </div>
                  </div>

                  <ul className="space-y-4 mb-8">
                    {plan.features.map((feature, index) => (
                      <li key={index} className="flex items-start">
                        <Check className="h-5 w-5 text-accent-green mr-2 flex-shrink-0" />
                        <span className="text-black text-sm">{feature}</span>
                      </li>
                    ))}
                  </ul>

                  <button
                    onClick={() => handlePlanSelection(plan)}
                    disabled={subscription?.plan?.id === plan.id}
                    className={`
                      w-full py-3 px-4 rounded-xl text-sm font-medium transition-colors border border-black
                      ${subscription?.plan?.id === plan.id
                        ? 'bg-gray-700 text-gray-400 cursor-not-allowed'
                        : 'bg-accent-green text-black hover:opacity-90'
                      }
                    `}
                  >
                    {subscription?.plan?.id === plan.id ? 'Current Plan' : 'Select Plan'}
                  </button>
                </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}